export default {
	companyList: [], //保险公司
	search: {}, //查询数据
	tableLoading: false, //表格loading
	tabActive: "1",
	columns: [ //表格字段
		{
			title: "序号",
			align: "center",
			type: "index",
		},
		{
			title: "考试分类",
			key: "name",
			align: "center",
		},
		{
			title: "排序",
			key: "orderNum",
			align: "center",
		},

		{
			title: "操作",
			slot: "action",
			align: "center",
		},
	],
	tableData: [], //表格数据
	total: 0, //表格记录数
	pageSize: 10, //页容量
	pageNum: 1, //当前页
	form: {}, //表单数据
	formVisible: false, //表单弹窗
}
